import { createRouter,createWebHistory } from 'vue-router'
// 引入的通用路由
import commonRoute from './routerModules/commonRouter'

//晚餐
import {dinnerRoute} from './routerModules/dinnerRouter';

// 整合所有的模块路由
let moduleRoute = []
    .concat(dinnerRoute);

// 3. 创建路由实例并传递 `routes` 配置。
const router = createRouter({
    history: createWebHistory(),
    routes:[...commonRoute,...moduleRoute],
})

router.beforeEach((to, from, next) => {
    if (to.matched.length === 0){
        from.name ? next({name: from.name}) : next("/404");
    }else {
        next();
    }
})
export default router
